<template>
  <v-layout row class="mx-0 ">
    <v-layout row class="px-3 py-3 align-center justify-space-between">
      <v-flex sm2>
        <v-autocomplete
            :items="years"
            @change="fetchPreviousStayLog"
            class="ml-2"
            flat
            label="Filter by Visa Year"
            outlined
            hide-details
            solo
            v-model="filters.visa_year"
        />
      </v-flex>

      <v-flex xs6 class="text-right" v-if="logs">
        <div class="px-3 py-2 text-subtitle-2">
          {{ logs.length }} visa in selected visa year
          <span class="ml-5 text-subtitle-2 font-weight-bold">Total PS: {{ totalStayDuration(logs) }} Days</span>
        </div>
      </v-flex>
    </v-layout>

    <v-flex xs12>
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">Visa Year</th>
            <th class="text-left">Visa Number</th>
            <th class="text-left">Visa type</th>
            <th class="text-left">Visa Duration</th>
            <th class="text-left">Stay Days</th>
          </tr>
          </thead>
          <tbody v-if="logs.length > 0">
          <tr v-for="(log, index) in logs" :key="index">
            <td>{{ log.visa_year }}</td>
            <td>{{ log.visa_number }}</td>
            <td>{{ log.visa_type }}</td>
            <td>
              {{ log.start_date + ' to ' + log.expiry_date }}
              <span v-if="log.duration" class="text-subtitle-2">
                ({{ log.duration }}) Days
              </span>
            </td>
            <td>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn fab x-small class="mr-2" color="" text elevation="0" @click="viewDurations(log)" v-on="on">
                    {{ log.stay_duration_count }}
                  </v-btn>
                </template>
                <span>View Duration</span>
              </v-tooltip>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="5">No Record Available</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-flex>

    <v-dialog
        v-model="durationDialog"
        width="400"
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Stay Durations</span>
        </v-card-title>
        <v-card-text>
          {{ durationList.length }} Days
          <v-divider></v-divider>

          <v-chip class="ma-2 text-center" v-for="item in durationList">
            {{ item }}
          </v-chip>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              class="white--text"
              color="red darken-3"
              @click="durationDialog = false"
          >Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-layout>
</template>

<script>
import {VERSIONED_API_URL} from "../../config/config.js";
import Http from "axios";
import moment from "moment";
import {mapGetters} from "vuex";

export default {
  name: "TravellerPreviousStayLog",
  props: ['travellerId'],
  data() {
    return {
      logs: null,
      durationDialog: false,
      durationList: [],
      filters: {},
    }
  },
  computed: {
    years() {
      let end = new Date().getFullYear();
      return Array(end - 2013).fill().map((_, idx) => end - idx);
    }
  },
  methods: {
    totalStayDuration(items) {
      return items.reduce((accumulator, current) => accumulator + current.stay_duration_count, 0);
    },

    fetchPreviousStayLog() {
      Http.get(`${VERSIONED_API_URL}/travellers-histories/previous-stay-log/` + this.travellerId, {
        params: this.filters
      }).then(response => {
        this.logs = response.data;
      }).catch(error => {
        console.log('error', error)
      })
    },
    viewDurations(item) {
      this.durationList = item.stay_duration
      this.durationDialog = true
    }
  },
  mounted() {
    this.filters.visa_year = new Date().getFullYear();
    this.fetchPreviousStayLog()
  }
}
</script>
